export { default } from "./Tab";
export * from "./Tab";
